export const sponsorTypeOptions = [
  { value: "individual", english: "Individual", arabic: "فرد" },
  { value: "company", english: "Company", arabic: "شركة" },
];

